import React, { useEffect } from 'react';
import {
	Alert,
	Autocomplete,
	Button,
	Grid,
	Paper,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TableRow,
	TextareaAutosize,
	TextField,
	Tooltip,
	Typography,
} from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS } from '../utils/lists';
import {
	formatterCurrency,
	removeDuplicates,
	handleError,
	handleSuccess,
	whichStatus,
	whichStatusColor,
	columnStyle,
	whichTypeOfPacking,
	whichDivison,
	justCentered,
	handleInfo,
	baseAreas,
	adminAreas,
	handleWarning,
	getUniques,
	handleConfirmModal,
} from '../../helpers/utils';
import {
	getCatalogList,
	getDataByUrl,
	loadCatalogs,
} from '../../actions/catalogs';
import {
	addBias,
	deleteBias,
	getBiasInfo,
	registerBias,
	registerSubBias,
	resetBiases,
	setBiases,
	setCurrentBias,
	updateBias,
} from '../../actions/biases';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CheckIcon from '@mui/icons-material/Check';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import { useNavigate, useParams } from 'react-router';
import { registerIndividualArea } from '../../actions/individualAreas';
import { getOrderInfo, updateOrderImport } from '../../actions/orders';
import { formatDateMX } from '../../helpers/hours';
import { DialogTemplate } from '../dialogs/DialogTemplate';
import { BiasPartForm } from '../dialogs/BiasPartForm';
import { MultipleSelectCheckmarks } from '../utils/UtilsComponent';
import { registerEvent } from '../../actions/event';
import { isInteger } from 'formik';
import { PDFViewer } from './PDFViewer';
import { round2 } from '../../helpers/utils';
import { styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import { BiasSizesDialog } from '../orderTracking/DialogBiasInfo/BiasSizesDialog';
import { BiasVariablesDialog } from '../orderTracking/DialogBiasInfo/BiasVariablesDialog';
import { generateQuotationReport } from '../../actions/pdf';

const textAreStyle = {
	width: '85%',
	borderRadius: '8px',
	height: 75,
	fontFamily: 'Arial',
	fontSize: '17px',
	margin: '10px 0 15px 0',
	padding: '10px',
	borderColor: '#E1DEDD',
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#01579b',
		color: theme.palette.common.white,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

export const NewBiasForm4 = ({ edit = null }) => {
	// URL params
	const { idOrder = null, idBias = null } = useParams();

	// Navigation
	const navigate = useNavigate();

	// Define state to know if it's loading or not
	const [isLoading, setIsLoading] = useState(false);
	const [titleDialog, setTitleDialog] = useState('');

	// Current bias
	const [offsetBias, setOffsetBias] = useState(1);

	// Current bias
	const [selectedBias, setSelectedBias] = useState(null);

	// Sizes dialog
	const [openSizesDialog, setOpenSizesDialog] = useState(false);
	const handleOpenSizesDialog = () => setOpenSizesDialog(true);
	const handleCloseSizesDialog = () => setOpenSizesDialog(false);

	// Variables dialog
	const [openVariablesDialog, setOpenVariablesDialog] = useState(false);
	const handleOpenVariablesDialog = () => setOpenVariablesDialog(true);
	const handleCloseVariablesDialog = () => setOpenVariablesDialog(false);

	// Editing
	const [editing, setEditing] = useState(false);
	const [currentVariableItem, setCurrentVariableItem] = useState(null);
	const [newPrice, setNewPrice] = useState(0);

	// Editing total unit price
	const [editingTotalUnitPrice, setEditingTotalUnitPrice] = useState(false);
	const [newTotalUnitPrice, setNewTotalUnitPrice] = useState(0);
	const [wasModified, setWasModified] = useState(false);

	// Was modified list of variables
	const [wasModifiedVariables, setWasModifiedVariables] = useState(false);

	// Define state to know if it's loading or not
	const [paymentDetails, setPaymentDetails] = useState({
		conditions: '',
		bankDetails: '',
		validityOfQuotation: '',
	});

	// Money
	const [moneyDetail, setMoneyDetails] = useState({
		subtotal_global: 0,
		iva_global: 0,
		total_price_global: 0,
		discount: 0,
	});

	// Discount
	const [discount, setDiscount] = useState(0);

	// Areas
	const { garment: garments = [], fabric: fabrics = [] } = useSelector(
		(state) => state.catalogs
	);

	// Form
	const [status, setStatus] = useState('No empezado');
	const [units, setUnits] = useState('');
	const [unitPrice, setUnitPrice] = useState('');
	const [subtotal, setSubTotal] = useState('');
	const [totalPrice, setTotalPrice] = useState('');
	const [description, setDescription] = useState('');
	const [observations, setObservations] = useState('');
	const [IVACost, setIVACost] = useState('');
	const [garmentTmp, setGarmentTmp] = useState('');
	const [garment, setGarment] = useState(null);
	const [variant, setVariant] = useState(null);
	const [fabric, setFabric] = useState(null);
	const [variable, setVariable] = useState([]);

	// Embroidery & Stamped
	const [embroideryDone, setEmbroideryDone] = useState(edit);
	const [stampedDone, setStampedDone] = useState(edit);
	const [sizesDone, setSizesDone] = useState(false);

	// Filename
	const [filename, setFilename] = useState('');

	// Areas form
	const [areas, setAreas] = useState();

	// Order
	const [order, setOrder] = useState(null);

	// Changes in variables prices
	const [changesVariablePrices, setChangesVariablePrices] = useState([]);

	// Current bias summary
	const [summary, setSummary] = useState(null);

	// Catalogs
	const [variants, setVariants] = useState([]); // Variants
	const [variables, setVariables] = useState(null); // Variables
	const [colors, setColors] = useState([]); // Colors
	const [sizes, setSizes] = useState([]); // Sizes

	const reset = () => {
		// Reset states
		setStatus(null);
		setUnits('');
		setUnitPrice('');
		setSubTotal('');
		setObservations('');
		setTotalPrice('');
		setDescription('');
		setGarment(null);
		setGarmentTmp(null);
		setVariant(null);
		setVariable([]);
		setFabric(null);
		setVariables(null);
		setEmbroideryDone(false);
		setStampedDone(false);
		setSizesDone(false);
	};

	// Current user
	const { user } = useSelector((state) => state);
	// Current bias
	const { currentBias, biases: biasesStore } = useSelector(
		(state) => state.biases
	);

	const dispatch = useDispatch();

	const handleSetCurrentBias = (data) => {
		dispatch(setCurrentBias(data));
	};

	const getVariables = (
		modifiedArray = null,
		unitPriceBasicGarment = false
	) => {
		let x = [];
		unitPriceBasicGarment = unitPriceBasicGarment
			? unitPriceBasicGarment
			: summary?.unitPriceBasicGarment || 0;
		if (variable?.length > 0) {
			let newVariables = [];
			if (wasModifiedVariables) {
				newVariables = modifiedArray
					? modifiedArray
					: summary?.variables;
			} else {
				// Get names of the current variables on the array
				const currentVariables = summary?.variables?.map(
					({ name }) => name
				);

				// Exclude already listed items
				newVariables = variables?.filter(
					(item) => !currentVariables.includes(item.name)
				);

				// Get new items
				newVariables = newVariables?.filter((item) =>
					variable.includes(item.name)
				);

				// Join old with new ones
				newVariables = [...summary?.variables, ...newVariables];

				// Last filter to check deselected items
				newVariables = newVariables.filter(({ name }) =>
					variable.includes(name)
				);
			}

			let unitPrices = [];

			// Calculate variables prices
			x = newVariables.map((item, index) => {
				if (index === 0) {
					// The first one
					const unitImport = unitPriceBasicGarment + item.price;
					unitPrices.push(unitImport);
					return {
						...item,
						unitImport,
					};
				} else {
					// Any other
					const latestUnitImport = unitPrices.pop();
					const unitImport = latestUnitImport + item.price;
					unitPrices.push(unitImport);
					return {
						...item,
						unitImport,
					};
				}
			});
		}
		return x;
	};

	const handleSetNewTotalUnitPrice = () => {
		if (summary?.unitPriceBasicGarment !== round2(newTotalUnitPrice)) {
			// Add changes in prices
			setChangesVariablePrices((old) => [
				...old,
				{
					name: 'Prenda básica',
					oldPrice: summary?.unitPriceBasicGarment || 0,
					newPrice: round2(newTotalUnitPrice),
				},
			]);
		}

		handleUpdateCurrentBias(true);
	};

	// Update current bias info.
	const handleUpdateCurrentBias = (notRecalculate = true) => {
		// Calculate unit price for the basic garment
		let unitPriceBasicGarment = 0;
		const currentVariant =
			variants?.find(({ name }) => variant === name) || null;

		const variantPrice = currentVariant?.price || 0;

		if (wasModified && notRecalculate) {
			// Set new total unit price
			unitPriceBasicGarment = newTotalUnitPrice;
		} else {
			if (summary?.subbiases?.length > 0) {
				// Prices
				let prices = [];
				let prices2 = [];

				// Current subbiases (sizes)
				const sizes = summary?.subbiases;

				// Get unique sizes
				const percentages = getUniques(
					sizes.map(({ percentage }) => percentage)
				);

				// Calculate percentages prices
				percentages.forEach((uniquePercentage) => {
					// Calculate
					const price =
						variantPrice * uniquePercentage + variantPrice;
					prices2.push({
						price,
						operation: `${variantPrice} * ${uniquePercentage} + ${variantPrice}`,
					});
					// Add price
					prices.push(price);
				});

				// Mean price
				unitPriceBasicGarment =
					prices.reduce((sum, price) => sum + price, 0) /
					percentages.length;
			} else {
				unitPriceBasicGarment = variantPrice;
			}
		}

		setNewTotalUnitPrice(round2(unitPriceBasicGarment));
		const newVariables = getVariables(null, round2(unitPriceBasicGarment));
		const sumOfSizes = newVariables?.pop()?.unitImport || 0;
		const tmpGarment =
			garments?.find(({ name }) => garment === name) || null;

		const newCurrentBias = {
			...summary,
			garment: tmpGarment,
			variant: currentVariant,
			fabric:
				fabrics?.find(
					({ name, color }) => fabric === `${name} - ${color}`
				) || null,
			variables: getVariables(null, round2(unitPriceBasicGarment)),
			unitPriceBasicGarment:
				currentVariant === null ? 0 : unitPriceBasicGarment,
			totalImport: sumOfSizes * units,
		};

		// Set local state
		setSummary(newCurrentBias);
	};

	// Handle submit
	const handleSubmit = (redux, exit = false) => {
		const finalUnitPrice =
			parseFloat(String(unitPrice).length > 0 ? unitPrice : 0).toFixed(
				2
			) || 0;
		const formData = {
			...currentBias,
			status: STATUS.find((item) => item.label === status)?.name || 'NST',
			units: parseInt(units) || 0,
			unit_price: finalUnitPrice,
			subtotal: parseFloat(units * finalUnitPrice).toFixed(2) || 0,
			total_price:
				parseFloat(units * finalUnitPrice * 1.16).toFixed(2) || 0,
			description:
				description.length > 0 ? description : 'Sin descripción',
			observations:
				observations.length > 0 ? observations : 'Sin observaciones',
			garment: garment?.id || null,
			variant: variant?.id || null,
			fabric: fabric?.id || null,
			variable: Array.isArray(variables) && variables.length > 0
				? variables.filter((item) => variable.includes(item.name)).map((item) => item.id)
				: currentBias?.variable_ids || [],
			order: idOrder,
			created_by: user.id,
			subbiases: currentBias?.subbiases || [], // Adding "subbiases"
		};

		if (order?.type === 'QUO') {
			// Set selected unit price for basic garment
			formData.unit_price = summary?.unitPriceBasicGarment;
			formData.subtotal = round2(summary?.totalImport);
			formData.total_price = round2(summary?.totalImport * 1.16);
		}

		if (redux) {
			handleSetCurrentBias(formData);
		} else {
			if (garment === null) {
				handleWarning('Se necesita seleccionar una prenda');
			} else {
				uploadToDB(formData);
				dispatch(setCurrentBias(null));
			}
		}
		if (exit) {
			handleExit();
		}
	};

	const checkUnitsMatch = (formData) => {
		if (edit) return true;
		// Total current units
		let sum = 0;
		formData?.subbiases?.forEach((item) => {
			sum += item.units;
		});
		return Number(units) === Number(sum);
	};

	const recalculateMoney = (biases) => {
		// Calculate subtotal, iva and total
		const subtotal_global_1 = biases.reduce(
			(sum, { totalImport }) => sum + totalImport,
			0
		);

		const subtotal_global_2 =
			subtotal_global_1 -
			subtotal_global_1 * (parseFloat(discount) / 100);

		// IVA global
		const iva_global = subtotal_global_2 * 0.16;

		// Total global import
		const total_price_global = subtotal_global_2 * 1.16;

		// Set money details
		setMoneyDetails({
			subtotal_global: round2(subtotal_global_1),
			iva_global: round2(iva_global),
			total_price_global: round2(total_price_global),
			discount: round2(subtotal_global_1 * (parseFloat(discount) / 100)),
		});
	};

	// Handle delete user with modal confirmation
	const handleDeleteAllBiases = (id) => {
		handleConfirmModal(
			'Precaución',
			'Todas las partidas creadas al momento serán eliminadas. Debes de hacer clic en "Guardar y salir" para aplicar los cambios.',
			'warning',
			'Sí, borrar'
		)
			.then(({ isConfirmed }) => {
				if (isConfirmed) {
					// Delete all biases
					biasesStore?.forEach(({ id, key }) => {
						deleteBias(id)
							.then(() => {
								handleSuccess(
									`Partida ${key} eliminada correctamente.`
								);
								const newBiases = biasesStore.filter(
									(item) => item.id !== id
								);

								// Set new biases
								dispatch(setBiases(newBiases));
							})
							.catch((error) => {
								handleError(
									error,
									'No se pudo eliminar la partida.'
								);
							});
					});

					// Exit
					handleExit();
				}
			})
			.catch((error) => handleError(error));
	};

	// Handle delete user with modal confirmation
	const handleDelete = (id) => {
		handleConfirmModal(
			'Precaución',
			'¿Seguro que deseas borrar la partida?',
			'warning',
			'Sí, borrar'
		)
			.then(({ isConfirmed }) => {
				if (isConfirmed) {
					deleteBias(id)
						.then(() => {
							handleSuccess('Partida eliminada correctamente.');
							const newBiases = biasesStore.filter(
								(item) => item.id !== id
							);

							// Set new biases
							dispatch(setBiases(newBiases));
						})
						.catch((error) => {
							handleError(
								error,
								'No se pudo eliminar la partida.'
							);
						});
				}
			})
			.catch((error) => handleError(error));
	};

	const uploadToDB = (formData) => {
		if (checkUnitsMatch(formData)) {
			if (edit) {
				updateBias(idBias, formData)
					.then(() => {
						handleSuccess('Partida actualizada correctamente.');
						handleExit();
					})
					.catch((error) => {
						handleError(error, 'No se pudo actualizar la partida.');
					});
			} else {
				// Status: Not Started
				const initialStatus = 'NST';
				handleInfo('Creando partida con sus tallas...');
				registerBias({
					...formData,
					status: initialStatus,
					delivery_forecast: order.delivery_date_original,
				})
					.then(async ({ data: newBias }) => {
						// New bias
						const newData = { ...newBias, ...summary };

						// Add bias to array
						dispatch(addBias([newData]));

						// Biases
						const biases = [...biasesStore, newData];

						// Update bias info
						handleUpdateCurrentBias();

						// Recalculate money
						recalculateMoney(biases);

						// Create event
						await registerEvent({
							title: 'Nueva partida',
							description: `Se registró una nueva partida de la prenda ${garment} con ${formData.units} unidades.`,
							type: 'INF',
							created_by: user.id,
							bias: newBias.id,
						});

						areas.forEach((area) => {
							// LOAD AREAS
							registerIndividualArea({
								name: area.name,
								days: area.days,
								bias: newBias.id,
							}).catch((error) => {
								handleError(
									error,
									`Hubo un error al intentar crear el área "${area.name}"
									en la partida "${newBias.key}"`
								);
							});
						});
						// LOAD BIASES
						formData.subbiases.forEach(({ units, size }, i) => {
							registerSubBias({
								name: `${i + 1}`,
								units: units,
								size: sizes.find((item) => item.name === size)
									.id,
								bias: newBias.id,
								delivery_forecast: order.delivery_date_original,
								created_by: user.id,
							})
								.then(async () => {
									await registerEvent({
										title: 'Nueva talla',
										description: `Se registró la talla "${size}" con ${units} unidades.`,
										type: 'INF',
										created_by: user.id,
										bias: newBias.id,
									});
								})
								.catch((error) => {
									handleError(
										error,
										'Hubo un error al intentar crear la talla'
									);
								});
						});
						handleSuccess('Partida agregada correctamente.');

						setOffsetBias((old) => old + 1);
						// Reset form
						reset();
					})
					.catch((error) => {
						handleError(error, 'No se pudo agregar la partida.');
					});
			}
			setIsLoading(false);
		} else {
			handleError(
				null,
				'Las unidades no concuerdan con el total de unidades que agregó'
			);
		}
	};

	const TextFieldComponent = (params, label) => (
		<TextField
			fullWidth
			required
			margin='normal'
			{...params}
			label={label}
		/>
	);

	useEffect(() => {
		dispatch(resetBiases());
		dispatch(loadCatalogs());
	}, []);

	useEffect(() => {
		if (discount.length > 0) {
			// Recalculate money
			recalculateMoney(biasesStore);
		}
	}, [discount]);

	useEffect(() => {
		handleUpdateCurrentBias();
	}, [
		variable,
		fabric,
		sizes,
		units,
		variant,
		summary?.subbiases,
		summary?.unitPriceBasicGarment,
	]);

	useEffect(() => {
		const garmentTmp = garments.find((item) => item.name === garment);
		setFilename(garmentTmp?.filename);
		const garmentId = garmentTmp?.id || null;
		if (garmentId) {
			getDataByUrl(`/api/catalog/variant/?garment=${garmentId}`).then(
				({ data: res }) => {
					setVariants(res.results);
				}
			);
			getDataByUrl(`/api/catalog/variable/`).then(({ data: res }) => {
				setVariables(res.results);
			});
		} else {
			setVariants([]);
			setVariables([]);
		}
	}, [garment]);

	useEffect(() => {
		if (units.length > 0 && unitPrice.length > 0) {
			const subTotalTmp = parseFloat(units) * parseFloat(unitPrice);
			const IVA = 0.16;
			const IVACostTmp = subTotalTmp * IVA;
			setSubTotal(subTotalTmp);
			setIVACost(IVACostTmp);
			setTotalPrice(subTotalTmp + IVACostTmp);
		}
	}, [units, unitPrice]);

	useEffect(() => {
		if (garment !== garmentTmp) {
			// Update garment pivot
			setGarmentTmp(garment);
			// Update almost all the form
			setVariant(null);
			setVariable([]);
			setFabric(null);
		}
	}, [garment]);

	useEffect(() => {
		getOrderInfo(idOrder).then(({ data }) => {
			setOrder({
				...data,
				status: {
					name: whichStatus(data.status),
					color: whichStatusColor(data.status),
				},
				entry_date: formatDateMX(data.entry_date),
				delivery_date: formatDateMX(data.delivery_date),
				delivery_date_original: data.delivery_date, // It's for new biases and subbiases
				delivery_forecast: formatDateMX(data.delivery_forecast),
				client: data.client_id,
				created_by: {
					...data.created_by,
					fullname: `${data.created_by.first_name} ${
						data.created_by.last_name.split(' ')[0]
					}`,
				},
				type_of_packing: whichTypeOfPacking(data.type_of_packing),
				division: whichDivison(data.division),
				amount: `${formatterCurrency(data.amount)}`,
				amountNumber: data.amount,
			});
		});
		getCatalogList('area').then(({ data }) => {
			const baseAreasNames = baseAreas.map((item) => item.name);
			const productionAreas = data.results.filter(
				(item) =>
					baseAreasNames.includes(item.name) &&
					!adminAreas.includes(item.name)
			);
			setAreas(productionAreas);
		});
		getCatalogList('color').then(({ data }) => {
			setColors(data.results);
		});
		getCatalogList('size').then(({ data }) => {
			setSizes(data.results);
		});
	}, []);

	useEffect(() => {
		if (edit) {
			getBiasInfo(idBias).then(({ data }) => {
				// SET STATES
				setStatus(data ? whichStatus(data.status) : null);
				setUnits(data ? data.units : '');
				setUnitPrice(data ? data.unit_price : '');
				setSubTotal(data ? data.subtotal : '');
				setTotalPrice(data ? data.total_price : '');
				setDescription(data ? data.description : '');
				setObservations(data ? data.observations : '');
				setGarment(data ? data.garment : null);
				setGarmentTmp(data ? data.garment : null);
				setVariant(data ? data.variant : null);
				setFabric(data ? data.fabric : null);
				setVariable(data ? data.variable.map((item) => item.name) : []);

				// SET STORE
				dispatch(
					setCurrentBias({
						// Genral info
						status: whichStatus(data.status),
						units: String(data.units),
						unit_price: String(data.unit_price),
						subtotal: data.subtotal,
						total_price: data.total_price,
						description: data.description,
						observations: data.observations,
						garment: data?.garment,
						variant: data?.variant,
						fabric: data?.fabric,
						variable: data.variable.map((item) => item.name),
						variable_ids: data.variable.map((item) => item.id),
						order: data?.order?.id,
						// Embroidery & Stamped
						back_embroidery: data?.back_embroidery,
						front_embroidery: data?.front_embroidery,
						sleeves_embroidery: data?.sleeves_embroidery,
						embroidery_type: data?.embroidery_type,
						embroidery_color: data?.embroidery_color,
						measures_embroidery: data?.measures_embroidery,
						notes_embroidery: data?.notes_embroidery,
						back_stamped: data?.back_stamped,
						front_stamped: data?.front_stamped,
						sleeves_stamped: data?.sleeves_stamped,
						stamped_type: data?.stamped_type,
						stamped_color: data?.stamped_color,
						measures_stamped: data?.measures_stamped,
						notes_stamped: data?.notes_stamped,
					})
				);
			});
			getDataByUrl('/api/catalog/variable/').then(({ data: res }) => {
				setVariables(res.results);
			});
		}
	}, []);

	// Dialog
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
		handleSubmit(true);
	};
	const handleClose = () => setOpen(false);

	const GridItemStyle = {
		...justCentered,
		border: '1px solid transparent',
	};

	const handleExit = () => {
		const path = `/dashboard/order/${idOrder}`;
		localStorage.setItem('lastPathPilu', path);
		localStorage.setItem('currentPathPilu', path);
		navigate(path);
	};

	useEffect(() => {
		if (isInteger(parseInt(units))) {
			handleWarning('Las unidades deben ser enteras');
			setUnits('');
		}
	}, [units]);

	const handleUpdateImport = () => {
		const newImport = parseFloat(
			(order?.amountNumber + moneyDetail.total_price_global).toFixed(2)
		);
		handleConfirmModal(
			'Guardar cotización',
			`¿Estás seguro de completar la cotización? Esto guardará el importe total acumulado al momento con el importe actual de la cotización: ${money(
				moneyDetail.total_price_global
			)} + ${money(order?.amountNumber)} = ${money(newImport)}`,
			'warning',
			'Sí, guardar',
			true
		)
			.then(({ isConfirmed }) => {
				if (isConfirmed) {
					updateOrderImport(order.id, newImport)
						.then(({ data }) => {
							if (data.ok) {
								dispatch(resetBiases());
								handleSuccess(
									'Se actualizó el importe total de la orden'
								);
								handleExit();
							} else {
								handleError(
									null,
									'Ocurrió un error al intentar actualizar el importe [1]'
								);
							}
						})
						.catch((error) => {
							handleError(
								error,
								'Ocurrió un error al intentar actualizar el importe [2]'
							);
						});
				}
			})
			.catch((error) => {
				handleError(
					error,
					'Ocurrió un error en el modal para actualizar el importe'
				);
			});
	};

	const handleUpdatePrice = (variableId) => {
		// Current variables
		// const variables = currentBias.variables;
		const variablesTmp = summary.variables;

		// Get current variable
		const currentVariable = variablesTmp.find(
			(item) => item.id === variableId
		);

		// Get index of the current variable
		const index = variablesTmp.findIndex((item) => item.id === variableId);

		// Update index with the updated price
		variablesTmp[index] = {
			...currentVariable,
			price: parseFloat(newPrice),
		};

		const modifiedVariables = getVariables(variablesTmp);
		const totalImport =
			(modifiedVariables[modifiedVariables.length - 1].unitImport || 0) *
			units;

		setSummary({
			...summary,
			variables: modifiedVariables,
			totalImport: totalImport,
		});

		// Reset current variable item
		setCurrentVariableItem(null);
	};

	const changeStateEditingPrice = (variable) => {
		setWasModifiedVariables(true);
		if (editing) {
			// Update variable price
			handleUpdatePrice(variable.id);

			if (variable.price !== newPrice) {
				// Add changes in prices
				setChangesVariablePrices((old) => [
					...old,
					{
						name: `Variable: ${variable.name}`,
						oldPrice: variable.price,
						newPrice,
					},
				]);
			}
		} else {
			// Set current variable
			setCurrentVariableItem(variable.id);
			// Set new price
			setNewPrice(variable.price);
		}
		// Change editing state
		setEditing(!editing);
	};

	const preparePDF = async () => {
		const userTmp = user;

		delete userTmp.img_profile;
		delete userTmp.token;
		delete userTmp.password;

		// Payload
		const payload = {
			quotationKey: order?.number_order,
			client: order?.client,
			division: order?.division,
			salesConsultant: userTmp,
			biases: biasesStore,
			subtotal: moneyDetail.subtotal_global,
			iva: moneyDetail.iva_global,
			totalImport: moneyDetail.total_price_global,
			discount: moneyDetail.discount,
			discountPercentage: parseFloat(discount),
			payment: paymentDetails,
		};

		await generateQuotationReport(payload);
	};

	const SizesButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '18px 0 0 0',
			}}
			size='large'
			type='submit'
			color={sizesDone || edit ? 'success' : 'primary'}
			variant='outlined'
			disabled={
				order?.type !== 'QUO' && (units === '' || unitPrice === '')
			}
			onClick={() => {
				setTitleDialog('Tallas');
				handleOpen();
			}}
		>
			Tallas
		</Button>
	);

	const BordadoButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '18px 0 0 0',
			}}
			size='large'
			type='submit'
			color={embroideryDone ? 'success' : 'primary'}
			variant='outlined'
			disabled={
				order?.type !== 'QUO' && (units === '' || unitPrice === '')
			}
			onClick={() => {
				setTitleDialog('Bordado');
				handleOpen();
			}}
		>
			Bordado
		</Button>
	);

	const EstampadoButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '18px 0 0 0',
			}}
			size='large'
			type='submit'
			variant='outlined'
			disabled={
				order?.type !== 'QUO' && (units === '' || unitPrice === '')
			}
			color={stampedDone ? 'success' : 'primary'}
			onClick={() => {
				setTitleDialog('Estampado');
				handleOpen();
			}}
		>
			Estampado
		</Button>
	);

	const PrintPDFButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '12px 0 0 0',
			}}
			size='large'
			color='secondary'
			variant='outlined'
			onClick={() => preparePDF()}
		>
			Imprimir PDF
		</Button>
	);

	const AddBiasButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '12px 0 0 0',
			}}
			// disabled={!(embroideryDone && stampedDone && (sizesDone || edit))}
			size='large'
			fullWidth
			variant='outlined'
			color='primary'
			onClick={() => {
				handleSubmit(false);
			}}
		>
			{edit ? 'Actualizar' : 'Agregar'}
		</Button>
	);

	const ExitButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '12px 0 0 0',
			}}
			fullWidth
			size='large'
			variant='outlined'
			color='error'
			onClick={() => {
				if (biasesStore?.length > 0) {
					handleDeleteAllBiases();
				} else {
					handleExit();
				}
			}}
		>
			Salir
		</Button>
	);

	const FinishButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '12px 0 0 0',
			}}
			fullWidth
			size='large'
			variant='outlined'
			color='success'
			onClick={() => {
				handleUpdateImport();
			}}
		>
			Terminar y salir
		</Button>
	);

	const CancelButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '12px 0 0 0',
			}}
			fullWidth
			size='large'
			variant='outlined'
			color='error'
			onClick={() => {
				reset();
			}}
		>
			Cancelar
		</Button>
	);

	const AddBiasAndExit = () => (
		<Button
			style={{
				width: '80%',
				margin: '12px 0 0 0',
			}}
			size='large'
			disabled={!(embroideryDone && stampedDone && (sizesDone || edit))}
			color='success'
			variant='outlined'
			onClick={() => {
				handleSubmit(false, true);
			}}
		>
			Crear y salir
		</Button>
	);

	const ResetVariablesButton = () => (
		<Button
			style={{
				width: '80%',
				margin: '12px 0 0 0',
			}}
			size='large'
			variant='outlined'
			onClick={() => setVariable([])}
		>
			Limpiar variables
		</Button>
	);

	const columnStyleCell = {
		headerClassName: 'column-header-pilu',
		headerAlign: 'center',
	};

	const iconButtonStyle = { color: '#143f6c' };

	const itemIconButton = { width: '50%', margin: '0 auto' };

	// Define columns
	const columns = [
		{
			field: 'id',
			headerName: '#',
			...columnStyleCell,
			width: 20,
			renderCell: ({ row }) => (
				<span className='table-cell-trucate'>{row?.id}</span>
			),
		},
		{
			field: 'actions',
			headerName: 'Acciones',
			...columnStyleCell,
			width: 150,
			renderCell: ({ row }) => (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						margin: '0 auto',
						width: '100%',
					}}
				>
					<div style={itemIconButton}>
						<Tooltip
							title='Ver variables con precios'
							placement='bottom'
						>
							<IconButton
								style={iconButtonStyle}
								aria-label='profile'
								color='primary'
								onClick={() => {
									setSelectedBias({
										id: row.id,
										variables: row.variables,
										subbiases: null,
									});
									handleOpenVariablesDialog();
								}}
							>
								<FormatListBulletedIcon />
							</IconButton>
						</Tooltip>
					</div>
					<div style={itemIconButton}>
						<Tooltip title='Ver tallas' placement='bottom'>
							<IconButton
								style={iconButtonStyle}
								aria-label='sizes'
								color='primary'
								onClick={() => {
									setSelectedBias({
										id: row?.id,
										subbiases: row?.subbiases,
										variables: [],
									});
									handleOpenSizesDialog();
								}}
							>
								<CheckroomIcon />
							</IconButton>
						</Tooltip>
					</div>
					<div style={itemIconButton}>
						<Tooltip title='Eliminar' placement='bottom'>
							<IconButton
								style={iconButtonStyle}
								aria-label='delete'
								color='primary'
								onClick={() => {
									handleDelete(row?.id);
								}}
							>
								<DeleteIcon />
							</IconButton>
						</Tooltip>
					</div>
				</div>
			),
		},
		{
			field: 'units',
			headerName: 'Cantidad',
			...columnStyleCell,
			width: 100,
			renderCell: ({ row }) => (
				<Tooltip title={row?.units}>
					<span className='table-cell-trucate'>{row?.units}</span>
				</Tooltip>
			),
		},
		{
			field: 'garment',
			headerName: 'Prenda',
			...columnStyleCell,
			width: 130,
			renderCell: ({ row }) => (
				<Tooltip title={row?.garment?.name || ''}>
					<span className='table-cell-trucate'>
						{row?.garment?.name || ''}
					</span>
				</Tooltip>
			),
		},
		{
			field: 'unitPriceBasicGarment',
			headerName: 'Precio prenda básica',
			...columnStyleCell,
			width: 200,
			renderCell: ({ row }) => (
				<Tooltip title={money(row?.unitPriceBasicGarment) || ''}>
					<span className='table-cell-trucate'>
						{money(row?.unitPriceBasicGarment) || ''}
					</span>
				</Tooltip>
			),
		},
		{
			field: 'variant',
			headerName: 'Variante',
			...columnStyleCell,
			width: 270,
			renderCell: ({ row }) => (
				<Tooltip title={row?.variant?.name || ''}>
					<span className='table-cell-trucate'>
						{row?.variant?.name || ''}
					</span>
				</Tooltip>
			),
		},
		{
			field: 'fabric',
			headerName: 'Tela',
			...columnStyleCell,
			width: 270,
			renderCell: ({ row }) => (
				<Tooltip title={row?.fabric?.name || ''}>
					<span className='table-cell-trucate'>
						{row?.fabric?.name || ''}
					</span>
				</Tooltip>
			),
		},
		{
			field: 'totalImport',
			headerName: 'Subtotal',
			...columnStyleCell,
			width: 130,
			renderCell: ({ row }) => (
				<Tooltip title={money(row?.totalImport) || ''}>
					<span className='table-cell-trucate'>
						{money(row?.totalImport) || ''}
					</span>
				</Tooltip>
			),
		},
	];

	return (
		<div style={{ padding: '25px' }}>
			{/* Sizes dialog */}
			<BiasSizesDialog
				open={openSizesDialog}
				handleClose={handleCloseSizesDialog}
				bias={selectedBias}
				sizes={selectedBias?.subbiases || []}
			/>

			{/* Variables dialog */}
			<BiasVariablesDialog
				open={openVariablesDialog}
				handleClose={handleCloseVariablesDialog}
				variables={selectedBias?.variables || []}
			/>

			{/* Dialog template */}
			<DialogTemplate
				config={{
					open: open,
					handleClose: handleClose,
					btnCancel: false,
					btnConfirm: false,
					title: titleDialog,
					subtitle: '',
				}}
				content={
					<BiasPartForm
						order={order}
						handleClose={handleClose}
						type={titleDialog}
						colors={colors}
						sizes={sizes}
						setEmbroideryDone={setEmbroideryDone}
						setStampedDone={setStampedDone}
						setSizesDone={setSizesDone}
						globalUnits={units}
						handleUpdateCurrentBias={handleUpdateCurrentBias}
						setSummary={setSummary}
					/>
				}
			/>

			<div style={{ marginLeft: '30px' }}>
				<Text
					variant='h5'
					text={
						order?.type === 'ORD'
							? `${edit ? 'Editar' : 'Nueva'} partida${
									edit
										? '.'
										: ` (#${
												order?.current_number_of_biases +
													offsetBias || 1
										  })`
							  }`
							: 'Cotización '
					}
				/>
				<Alert severity='info'>
					Las opciones inactivas <b>no se encuentran disponibles</b>.
				</Alert>
			</div>

			{order && (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					<div
						style={{
							width: '50%',
						}}
					>
						<Grid container component='main' spacing={1}>
							<Grid item xs={12} style={GridItemStyle}>
								<Autocomplete
									required
									fullWidth
									style={{
										width: '90%',
										margin: '0 auto',
									}}
									value={garment}
									onChange={(_, value) => {
										setGarment(value);
										if (value?.id) {
											getDataByUrl(
												`/api/catalog/variant/?garment=${value.id}`
											).then(({ data: res }) => {
												setVariants(res.results);
											});
											getDataByUrl(
												`/api/catalog/variable/`
											).then(({ data: res }) => {
												setVariables(res.results);
											});
										} else {
											setVariants([]);
											setVariables([]);
										}
										handleUpdateCurrentBias();
									}}
									options={getUniques(garments)}
									getOptionLabel={(option) => option.name}
									getOptionDisabled={(option) =>
										option.control_status === 'INA'
									}
									isOptionEqualToValue={(option, value) =>
										option?.id === value?.id
									}
									key={garment?.id || garment?.name || ''}
									renderOption={(props, option) => (
										<li
											{...props}
											key={
												option.id ||
												`${option.name}-${
													option.color || ''
												}`
											}
										>
											{option.control_status === 'INA' ? (
												<Tooltip title='Este elemento está inactivo'>
													<span
														style={{
															color: 'gray',
														}}
													>
														{option.name}
													</span>
												</Tooltip>
											) : (
												option.name
											)}
										</li>
									)}
									renderInput={(params) =>
										TextFieldComponent(params, 'Prenda')
									}
								/>
							</Grid>

							<Grid item xs={12} style={GridItemStyle}>
								<Autocomplete
									required
									fullWidth
									style={{
										width: '90%',
										margin: '0 auto',
									}}
									value={variant}
									onChange={(_, value) => {
										setVariant(value);
										handleUpdateCurrentBias();
									}}
									options={getUniques(variants)}
									getOptionLabel={(option) => option.name}
									getOptionDisabled={(option) =>
										option.control_status === 'INA'
									}
									isOptionEqualToValue={(option, value) =>
										option?.id === value?.id
									}
									key={variant?.id || variant?.name || ''}
									renderOption={(props, option) => (
										<li
											{...props}
											key={
												option.id ||
												`${option.name}-${
													option.color || ''
												}`
											}
										>
											{option.control_status === 'INA' ? (
												<Tooltip title='Este elemento está inactivo'>
													<span
														style={{
															color: 'gray',
														}}
													>
														{option.name}
													</span>
												</Tooltip>
											) : (
												option.name
											)}
										</li>
									)}
									renderInput={(params) =>
										TextFieldComponent(params, 'Variantes')
									}
								/>
							</Grid>

							<Grid item xs={12} style={GridItemStyle}>
								<Autocomplete
									required
									fullWidth
									style={{
										width: '90%',
										margin: '0 auto',
									}}
									value={fabric}
									onChange={(_, value) => {
										setFabric(value);
										handleUpdateCurrentBias();
									}}
									options={getUniques(fabrics)}
									getOptionLabel={(option) =>
										option.name && option.color
											? `${option.name} - ${option.color}`
											: option.name || ''
									}
									getOptionDisabled={(option) =>
										option.control_status === 'INA'
									}
									isOptionEqualToValue={(option, value) =>
										option?.id === value?.id
									}
									key={fabric?.id || fabric?.name || ''}
									renderOption={(props, option) => (
										<li
											{...props}
											key={
												option.id ||
												`${option.name}-${
													option.color || ''
												}`
											}
										>
											{option.control_status === 'INA' ? (
												<Tooltip title='Este elemento está inactivo'>
													<span
														style={{
															color: 'gray',
														}}
													>
														{option.name &&
														option.color
															? `${option.name} - ${option.color}`
															: option.name || ''}
													</span>
												</Tooltip>
											) : option.name && option.color ? (
												`${option.name} - ${option.color}`
											) : (
												option.name || ''
											)}
										</li>
									)}
									renderInput={(params) =>
										TextFieldComponent(params, 'Telas')
									}
								/>
							</Grid>

							<Grid item xs={12} style={GridItemStyle}>
								<MultipleSelectCheckmarks
									label='Variables'
									fullWidth
									setState={setVariable}
									state={variable}
									areas={
										variables?.map((item) => item.name) ||
										[]
									}
									styleConfig={{
										width: '100%',
										margin: '0 auto',
										...justCentered,
									}}
									setWasModifiedVariables={
										setWasModifiedVariables
									}
								/>
							</Grid>

							<Grid
								item
								xs={6}
								style={{
									...GridItemStyle,
									marginTop: '10px',
								}}
							>
								<TextForm
									label='Unidades'
									value={units}
									setChange={setUnits}
									type='number'
								/>
							</Grid>

							<Grid item xs={6} style={GridItemStyle}>
								{order?.type === 'ORD' ? (
									<TextForm
										label='Precio unitario'
										value={unitPrice}
										setChange={setUnitPrice}
										type='number'
									/>
								) : (
									<SizesButton />
								)}
							</Grid>

							{order?.type === 'QUO' && (
								<Grid item xs={12} style={GridItemStyle}>
									<ExitButton width={100} />
								</Grid>
							)}

							{order?.type === 'ORD' && (
								<>
									<Grid
										item
										xs={4}
										style={{
											...GridItemStyle,
											margin: '15px 0 0 0',
										}}
									>
										<Text2
											title='Subtotal'
											text={money(
												parseFloat(units) *
													parseFloat(unitPrice) || 0
											)}
											var2='h6'
										/>
									</Grid>

									<Grid
										item
										xs={4}
										style={{
											...GridItemStyle,
											margin: '15px 0 0 0',
										}}
									>
										<Text2
											title='IVA'
											text={money(
												parseFloat(units) *
													parseFloat(unitPrice) *
													0.16 || 0
											)}
											var2='h6'
										/>
									</Grid>

									<Grid
										item
										xs={4}
										style={{
											...GridItemStyle,
											margin: '15px 0 0 0',
										}}
									>
										<Text2
											title='Precio total'
											text={money(
												parseFloat(units) *
													parseFloat(unitPrice) *
													1.16 || 0
											)}
											var2='h6'
										/>
									</Grid>
								</>
							)}
						</Grid>
					</div>
					<div
						style={{
							border: '1px solid transparent',
							width: '50%',
						}}
					>
						{order?.type === 'ORD' ? (
							<Grid container component='main' spacing={1}>
								<>
									<Grid
										item
										xs={edit ? 6 : 4}
										style={GridItemStyle}
									>
										<BordadoButton />
									</Grid>
									<Grid
										item
										xs={edit ? 6 : 4}
										style={GridItemStyle}
									>
										<EstampadoButton />
									</Grid>

									{!edit && (
										<Grid item xs={4} style={GridItemStyle}>
											<SizesButton />
										</Grid>
									)}

									<Grid
										item
										xs={12}
										style={{
											...GridItemStyle,
											margin: '15px 0 0 0',
										}}
									>
										<TextareaAutosize
											value={description}
											onChange={({ target }) =>
												setDescription(target.value)
											}
											aria-label='minimum height'
											minRows={5}
											variant='standard'
											placeholder='Descripción'
											style={{
												...textAreStyle,
											}}
										/>
									</Grid>

									<Grid
										item
										xs={12}
										style={{
											...GridItemStyle,
											margin: '15px 0 0 0',
										}}
									>
										<TextareaAutosize
											value={observations}
											onChange={({ target }) =>
												setObservations(target.value)
											}
											aria-label='minimum height'
											minRows={5}
											variant='standard'
											placeholder='Observaciones'
											style={{
												...textAreStyle,
											}}
										/>
									</Grid>

									<Grid item xs={6} style={GridItemStyle}>
										<ExitButton />
									</Grid>
									<Grid item xs={6} style={GridItemStyle}>
										<AddBiasButton />
									</Grid>
									<Grid item xs={6} style={GridItemStyle}>
										{variable?.length > 0 && (
											<ResetVariablesButton />
										)}
									</Grid>
									{!edit && (
										<Grid item xs={6} style={GridItemStyle}>
											{order?.type === 'ORD' && (
												<AddBiasAndExit />
											)}
										</Grid>
									)}
								</>
							</Grid>
						) : (
							<>
								{/* PDF VIEWER</> */}
								<PDFViewer filename={filename} />
							</>
						)}
					</div>
				</div>
			)}

			{summary?.garment && order?.type === 'QUO' && (
				<>
					{/* Separator */}
					<hr style={{ margin: '4em 0' }} />

					{/* Quotation engine */}
					<div style={{ margin: '0 0 0 30px' }}>
						<Text variant='h5' text='Resumen' />

						<Grid
							container
							component='main'
							spacing={2}
							style={{ margin: '20px 0 0 0' }}
						>
							{/* General data */}
							<Grid
								item
								xs={5}
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<Text variant='h6' text='Nueva partida' />
								<TableContainer component={Paper}>
									<Table
										sx={{ width: '100%' }}
										aria-label='customized table'
									>
										<TableHead>
											<StyledTableRow>
												<StyledTableCell align='left'>
													Artículo
												</StyledTableCell>
												<StyledTableCell align='left'>
													Tipo
												</StyledTableCell>
											</StyledTableRow>
										</TableHead>
										<TableBody>
											<StyledTableRow
												sx={{
													'&:last-child td, &:last-child th':
														{ border: 0 },
												}}
											>
												<StyledTableCell align='left'>
													Prenda
												</StyledTableCell>
												<StyledTableCell align='left'>
													{/* {capLetters( */}
													{summary?.garment?.name}
													{/* )} */}
												</StyledTableCell>
											</StyledTableRow>
											<StyledTableRow
												sx={{
													'&:last-child td, &:last-child th':
														{ border: 0 },
												}}
											>
												<StyledTableCell align='left'>
													Variante
												</StyledTableCell>
												<StyledTableCell align='left'>
													{/* {capLetters( */}
													{summary?.variant?.name}
													{/* )} */}
												</StyledTableCell>
											</StyledTableRow>
											<StyledTableRow
												sx={{
													'&:last-child td, &:last-child th':
														{ border: 0 },
												}}
											>
												<StyledTableCell align='left'>
													Tela
												</StyledTableCell>
												<StyledTableCell align='left'>
													{/* {capLetters( */}
													{summary?.fabric?.name}
													{/* )} */}
												</StyledTableCell>
											</StyledTableRow>
										</TableBody>
									</Table>
								</TableContainer>

								<br />

								<Text
									variant='h6'
									text={`Tallas (Total de incrementos: ${money(
										currentBias?.subbiases?.reduce(
											(sum, { percentage }) =>
												sum +
												summary?.unitPriceBasicGarment *
													percentage,
											0
										)
									)})`}
								/>
								<TableContainer component={Paper}>
									<Table
										sx={{ width: '100%' }}
										aria-label='customized table'
									>
										<TableHead>
											<StyledTableRow>
												<StyledTableCell align='center'>
													#
												</StyledTableCell>
												<StyledTableCell align='center'>
													Talla
												</StyledTableCell>
												<StyledTableCell align='center'>
													Unidades
												</StyledTableCell>
												<StyledTableCell align='center'>
													Incremento (%)
												</StyledTableCell>
												<StyledTableCell align='center'>
													Incremento ($)
												</StyledTableCell>
											</StyledTableRow>
										</TableHead>
										<TableBody>
											{currentBias?.subbiases?.map(
												(
													{ size, units, percentage },
													indexTable
												) => (
													<StyledTableRow
														key={`size-${size}`}
													>
														<StyledTableCell align='center'>
															{indexTable + 1}
														</StyledTableCell>
														<StyledTableCell align='center'>
															{size}
														</StyledTableCell>
														<StyledTableCell align='center'>
															{units}
														</StyledTableCell>
														<StyledTableCell align='center'>
															+{percentage * 100}%
														</StyledTableCell>
														<StyledTableCell align='center'>
															{money(
																summary?.totalImport *
																	percentage
															)}
														</StyledTableCell>
													</StyledTableRow>
												)
											)}
										</TableBody>
									</Table>
								</TableContainer>

								<br />

								<Text variant='h6' text='Precios' />
								<TableContainer component={Paper}>
									<Table
										sx={{ width: '100%' }}
										aria-label='customized table'
									>
										<TableHead>
											<StyledTableRow>
												<StyledTableCell align='center'>
													Prenda básica
												</StyledTableCell>
												<StyledTableCell align='center'>
													Subtotal
												</StyledTableCell>
												<StyledTableCell align='center'>
													IVA
												</StyledTableCell>
												<StyledTableCell align='center'>
													Importe total
												</StyledTableCell>
											</StyledTableRow>
										</TableHead>
										<TableBody>
											<StyledTableRow>
												<StyledTableCell align='center'>
													<div>
														{editingTotalUnitPrice ? (
															<>
																<TextField
																	autoFocus
																	variant='standard'
																	value={
																		newTotalUnitPrice
																	}
																	onChange={({
																		target,
																	}) => {
																		setNewTotalUnitPrice(
																			target.value
																		);
																	}}
																	onKeyDown={({
																		key,
																	}) => {
																		if (
																			key ===
																			'Enter'
																		) {
																			setWasModified(
																				true
																			);
																			setEditingTotalUnitPrice(
																				!editingTotalUnitPrice
																			);
																			handleSetNewTotalUnitPrice();
																		}
																	}}
																	label='Precio Negociado'
																/>
																<Tooltip
																	title='Guardar precio'
																	placement='bottom'
																>
																	<IconButton
																		style={{
																			color: '#143f6c',
																			margin: editingTotalUnitPrice
																				? '0 0 0 0'
																				: '5px 0 0 0',
																		}}
																		edge='end'
																		aria-label='comments'
																		onClick={() => {
																			setEditingTotalUnitPrice(
																				!editingTotalUnitPrice
																			);
																			handleSetNewTotalUnitPrice();
																		}}
																	>
																		<CheckIcon />
																	</IconButton>
																</Tooltip>
															</>
														) : (
															<>
																<div
																	style={{
																		display:
																			'flex',
																		flexDirection:
																			'row',
																		justifyContent:
																			'center',
																	}}
																>
																	<Text
																		variant='p'
																		text={money(
																			summary?.unitPriceBasicGarment
																		)}
																		bold={
																			false
																		}
																	/>
																	<Tooltip
																		title='Recalcular tallas'
																		placement='bottom'
																	>
																		<IconButton
																			style={{
																				color: '#143f6c',
																				margin: editingTotalUnitPrice
																					? '0 0 0 0'
																					: '-8px 0 0 12px',
																			}}
																			edge='end'
																			aria-label='comments'
																			onClick={() => {
																				handleUpdateCurrentBias(
																					false
																				);
																				setWasModified(
																					false
																				);
																			}}
																		>
																			<ClearIcon />
																		</IconButton>
																	</Tooltip>
																	<Tooltip
																		title='Editar precio negociado'
																		placement='bottom'
																	>
																		<IconButton
																			style={{
																				color: '#143f6c',
																				margin: editingTotalUnitPrice
																					? '0 0 0 0'
																					: '-8px 0 0 0',
																			}}
																			edge='end'
																			aria-label='comments'
																			onClick={() => {
																				setWasModified(
																					true
																				);
																				setEditingTotalUnitPrice(
																					!editingTotalUnitPrice
																				);
																			}}
																		>
																			<CreateIcon />
																		</IconButton>
																	</Tooltip>
																</div>
															</>
														)}
													</div>
												</StyledTableCell>
												<StyledTableCell align='center'>
													{money(
														summary?.totalImport
													)}
												</StyledTableCell>
												<StyledTableCell align='center'>
													{money(
														summary?.totalImport *
															0.16
													)}
												</StyledTableCell>
												<StyledTableCell align='center'>
													{money(
														summary?.totalImport *
															1.16
													)}
												</StyledTableCell>
											</StyledTableRow>
										</TableBody>
									</Table>
								</TableContainer>

								<br />

								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										margin: '10px 0',
										justifyContent: 'space-evenly',
									}}
								>
									<AddBiasButton />
									<div style={{ margin: '0 10px' }}></div>
									<CancelButton />
								</div>
							</Grid>

							{/* Pricing */}
							<Grid item xs={7}>
								<Text variant='h6' text='Variables' />

								<TableContainer component={Paper}>
									<Table
										sx={{ width: '100%' }}
										aria-label='simple table'
									>
										<TableHead>
											<StyledTableRow>
												<StyledTableCell align='center'>
													#
												</StyledTableCell>
												<StyledTableCell align='left'>
													Variable
												</StyledTableCell>
												<StyledTableCell align='center'>
													Precio por variable
												</StyledTableCell>
												<StyledTableCell align='center'>
													Importe unitario acumulado
												</StyledTableCell>
												<StyledTableCell align='center'>
													Subtotal
												</StyledTableCell>
											</StyledTableRow>
										</TableHead>
										<TableBody>
											{summary?.variables.map(
												(variable, indexTable) => (
													<StyledTableRow
														key={variable.name}
														sx={{
															'&:last-child td, &:last-child th':
																{ border: 0 },
														}}
													>
														<StyledTableCell align='center'>
															{indexTable + 1}
														</StyledTableCell>
														<StyledTableCell align='left'>
															{variable.name}
														</StyledTableCell>
														<StyledTableCell align='center'>
															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'row',
																	justifyContent:
																		'flex-end',
																}}
															>
																{currentVariableItem ===
																variable.id ? (
																	<TextField
																		autoFocus
																		style={{
																			width: '25%',
																			margin: '-10px 0 0 0',
																		}}
																		variant='standard'
																		value={
																			newPrice
																		}
																		onChange={({
																			target,
																		}) =>
																			setNewPrice(
																				target.value
																			)
																		}
																		onKeyDown={({
																			key,
																		}) => {
																			if (
																				key ===
																				'Enter'
																			) {
																				changeStateEditingPrice(
																					variable
																				);
																			}
																		}}
																		label='Precio'
																	/>
																) : (
																	<p
																		style={{
																			margin: '8px 0 0 0',
																		}}
																	>
																		{money(
																			variable.price
																		)}
																	</p>
																)}

																<IconButton
																	style={{
																		color: '#143f6c',
																		margin:
																			currentVariableItem ===
																			variable.id
																				? '0 0 0 0'
																				: '0 0 0 12px',
																	}}
																	edge='end'
																	aria-label='comments'
																	onClick={() => {
																		changeStateEditingPrice(
																			variable
																		);
																	}}
																>
																	{editing &&
																	currentVariableItem ===
																		variable.id ? (
																		<CheckIcon />
																	) : (
																		<CreateIcon />
																	)}
																</IconButton>
															</div>
														</StyledTableCell>
														<StyledTableCell align='center'>
															{money(
																variable.unitImport
															)}
														</StyledTableCell>
														<StyledTableCell align='center'>
															{money(
																variable.unitImport +
																	summary?.totalImport
															)}
														</StyledTableCell>
													</StyledTableRow>
												)
											)}
										</TableBody>
									</Table>
								</TableContainer>

								<br />

								{changesVariablePrices?.length > 0 && (
									<>
										<Text
											variant='h6'
											text='Cambios manuales en precios'
										/>

										<TableContainer component={Paper}>
											<Table
												sx={{ width: '100%' }}
												aria-label='simple table'
											>
												<TableHead>
													<StyledTableRow>
														<StyledTableCell align='center'>
															#
														</StyledTableCell>
														<StyledTableCell align='left'>
															Tipo
														</StyledTableCell>
														<StyledTableCell align='center'>
															Precio anterior
														</StyledTableCell>
														<StyledTableCell align='center'>
															Nuevo precio
														</StyledTableCell>
													</StyledTableRow>
												</TableHead>
												<TableBody>
													{changesVariablePrices.map(
														(
															{
																name,
																oldPrice,
																newPrice:
																	_newPrice,
															},
															indexTable
														) => (
															<StyledTableRow
																key={name}
																sx={{
																	'&:last-child td, &:last-child th':
																		{
																			border: 0,
																		},
																}}
															>
																<StyledTableCell align='center'>
																	{indexTable +
																		1}
																</StyledTableCell>
																<StyledTableCell align='left'>
																	{name}
																</StyledTableCell>
																<StyledTableCell align='center'>
																	{money(
																		oldPrice
																	)}
																</StyledTableCell>
																<StyledTableCell align='center'>
																	{money(
																		_newPrice
																	)}
																</StyledTableCell>
															</StyledTableRow>
														)
													)}
												</TableBody>
											</Table>
										</TableContainer>
									</>
								)}
							</Grid>
						</Grid>
					</div>
				</>
			)}

			{/* Current biases in Redux */}
			{order?.type === 'QUO' && biasesStore?.length > 0 && (
				<>
					{/* Separator */}
					<hr style={{ margin: '4em 0 3em 0' }} />

					{/* Current bias */}
					<div style={{ margin: '0 0 0 30px' }}>
						{/* Title */}
						<Text variant='h6' text='Resumen de la cotización' />

						{/* Datagrid */}
						<DataGrid
							style={{
								height: '350px',
								margin: '10px 0 0 0',
							}}
							density='compact'
							rows={biasesStore}
							columns={columns}
						/>

						{/* Money */}
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								margin: '20px 0 15px 0',
								justifyContent: 'space-evenly',
							}}
						>
							<Text2
								title='Importe actual de la cotización'
								text={order?.amount}
								var1='h6'
								var2='h6'
							/>
							<Text2
								title='Subtotal'
								text={money(moneyDetail.subtotal_global)}
								var1='h6'
								var2='h6'
							/>
							<br />
							<Text2
								title='Descuento'
								text={
									parseFloat(discount) === 0 ||
									discount.length === 0
										? 'No hay'
										: money(moneyDetail.discount)
								}
								var1='h6'
								var2='h6'
							/>
							<br />
							<Text2
								title='IVA'
								text={money(moneyDetail.iva_global)}
								var1='h6'
								var2='h6'
							/>
							<br />
							<Text2
								title='Importe total'
								text={money(moneyDetail.total_price_global)}
								var1='h6'
								var2='h6'
							/>
						</div>

						{/* PAYMENT DETAILS */}
						<Grid
							container
							component='main'
							spacing={2}
							style={{ margin: '10px 0 0 0' }}
						>
							<Grid item xs={4} style={GridItemStyle}>
								<TextField
									required
									style={{ width: '100%' }}
									label='Condiciones de pago'
									value={paymentDetails.conditions}
									placeholder='Condiciones de pago'
									multiline
									minRows={3}
									onChange={({ target }) =>
										setPaymentDetails((old) => ({
											...old,
											conditions: target.value,
										}))
									}
								/>
							</Grid>

							<Grid item xs={4} style={GridItemStyle}>
								<TextField
									required
									style={{ width: '100%' }}
									label='Datos bancarios'
									value={paymentDetails.bankDetails}
									multiline
									minRows={3}
									placeholder='Datos bancarios'
									onChange={({ target }) =>
										setPaymentDetails((old) => ({
											...old,
											bankDetails: target.value,
										}))
									}
								/>
							</Grid>
							<Grid item xs={4} style={GridItemStyle}>
								<TextField
									required
									style={{ width: '100%' }}
									label='Vigencia de la cotización'
									value={paymentDetails.validityOfQuotation}
									multiline
									minRows={3}
									placeholder='Vigencia de la cotización'
									onChange={({ target }) =>
										setPaymentDetails((old) => ({
											...old,
											validityOfQuotation: target.value,
										}))
									}
								/>
							</Grid>
							<Grid item xs={4} style={GridItemStyle}>
								<TextField
									required
									style={{ width: '100%' }}
									label='Descuento (%)'
									type='number'
									value={discount}
									placeholder='Descuento'
									onChange={({ target }) => {
										setDiscount(target.value);
									}}
								/>
							</Grid>
						</Grid>

						{/* Action buttons */}
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								margin: '10px 0',
								justifyContent: 'space-evenly',
							}}
						>
							<PrintPDFButton />
							<div style={{ margin: '0 10px' }}></div>
							<FinishButton />
						</div>
					</div>
				</>
			)}
		</div>
	);
};

const money = (amount = 0) => (amount ? `${formatterCurrency(amount)}` : '$0');

export const Text = ({ variant, text, bold = true }) => (
	<Typography variant={variant} gutterBottom>
		{bold ? <b>{text}</b> : text}
	</Typography>
);

export const Text2 = ({ title, text = '-', var1 = 'p', var2 = 'h4' }) => (
	<div style={columnStyle}>
		<Typography variant={var1}>
			<b>{title}</b>
		</Typography>
		<Typography variant={var2}>{text}</Typography>
	</div>
);

export const TextForm = ({ label, value, setChange, type = 'text' }) => (
	<TextField
		required
		type={type}
		style={{ width: '80%' }}
		label={label}
		value={value}
		onChange={({ target }) => setChange(target.value)}
	/>
);
